import React from 'react';

import { Surface } from '@infoods/lifebase-ui';

import classes from './NgzScanIqPaymentResult.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { SuccessfulResult } from './components/SuccessfulResult/SuccessfulResult';
import { FreeSuccessResult } from './components/FreeSuccessResult/FreeSuccessResult';
import { AlreadySubscribedResult } from './components/AlreadySubscribedResult/AlreadySubscribedResult';
import { ErrorInfo } from '../../components/payment-result/ErrorInfo/ErrorInfo';
import { collectSearchParams } from '../../utils/collectSearchParams/collectSearchParams';
import { useScanIqPaymentResult } from './hooks/useScanIqPaymentResult';
import { SCAN_IQ_PAYMENT_RESULT_TYPE } from '../../constants/scanIqPaymentResultType';

const NgzScanIqPaymentResult = () => {
  const { isSuccess, params, paymentInfo, paymentResultType } = useScanIqPaymentResult();

  // We should take the params from the URL before the '#!' part and move them after it
  // Stripe adding own params as a default query params, and we need to move them to the hash portion to be able angular router use them
  if (window.location.search.length) {
    collectSearchParams('scaniq-payment-result');

    return null;
  }

  const renderSuccessfulResult = () => {
    switch (paymentResultType) {
      case SCAN_IQ_PAYMENT_RESULT_TYPE.FREE:
        return (
          <FreeSuccessResult entityId={params.entityId} retryPath={params.retryPath} />
        );
      case SCAN_IQ_PAYMENT_RESULT_TYPE.ALREADY_SUBSCRIBED:
        return (
          <AlreadySubscribedResult
            entityId={params.entityId}
            retryPath={params.retryPath}
          />
        );
      default:
        return (
          <SuccessfulResult paymentInfo={paymentInfo} retryPath={params.retryPath} />
        );
    }
  };

  const renderContent = () => {
    if (!isSuccess) {
      return <ErrorInfo retryPath={params.retryPath} />;
    }

    return <Surface className={classes.box}>{renderSuccessfulResult()}</Surface>;
  };

  return <div className={classes.container}>{renderContent()}</div>;
};

angularizeWithProviders(NgzScanIqPaymentResult, 'ngzScanIqPaymentResult', {});
